import log from '@/logger/loglevel'

function trace(...args) {
  log.trace(...args)
}

function debug(...args) {
  log.debug(...args)
}

function info(...args) {
  log.info(...args)
}

function warn(...args) {
  log.warn(...args)
}

function error(...args) {
  log.error(...args)
}

export default {
  trace, debug, info, warn, error
}